import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const FILTERS_API_URL = 'portfolio/filter-options/'
const ANALYSE_FILTERS_API_URL = 'analysis/filters/'

export const fetchUserFilters = createAsyncThunk(
    'filters/fetchFilters',
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            if (!token) {
                return;
            }

            const response = await axios.get(FILTERS_API_URL, {
                params,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch trust list'
            );
        }
    }
);
export const fetchAnalyseFilters = createAsyncThunk(
    'filters/fetchAnalyseFilters',
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            if (!token) {
                return;
            }

            const response = await axios.get(ANALYSE_FILTERS_API_URL, {
                params,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch trust list'
            );
        }
    }
);

const initialState = {
    filter_list: [],
    loading: false,
    error: null,
    query: {},

    analyse_filters: [],
    analyse_filters_loading: false

};

const filtersSlice = createSlice({
    name: 'trust',
    initialState,
    reducers: {
        setQuery: (state, action) => {
            state.query = {
                ...state.query,
                ...action.payload
            };
        },
        clearQuery: (state) => {
            state.query = {};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserFilters.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserFilters.fulfilled, (state, action) => {
                state.loading = false;
                state.filter_list = action.payload;
            })
            .addCase(fetchUserFilters.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Something went wrong';
                state.filter_list = []
            })


            .addCase(fetchAnalyseFilters.pending, (state) => {
                state.analyse_filters_loading = true;
                // state.error = null;
            })
            .addCase(fetchAnalyseFilters.fulfilled, (state, action) => {
                state.analyse_filters_loading = false;
                state.analyse_filters = action.payload;
            })
            .addCase(fetchAnalyseFilters.rejected, (state, action) => {
                state.analyse_filters_loading = false;
                // state.error = action.payload || 'Something went wrong';
                state.analyse_filters = []
            });
    },
});

export default filtersSlice.reducer;
export const { setQuery, clearQuery } = filtersSlice.actions;
